import { useEffect } from "react";

/**
 * This hook is used to trigger a callback function once a component is loaded. Same as ComponentDidMount call in class component.
 * @param callback The callback function to trigger when the component is loaded.
 */
export function useMount(callback: () => void): void {
    // Remove dependency list so callback is only triggered once mounted.
    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(callback, []);
}
